import { register } from '@shopify/theme-sections';

register('header-section', {
  onLoad() {
    this.count = this.container.querySelectorAll('[data-cart-count]')

    window.PubSub.subscribe("cart:updated", this.updateHeaderCartCount.bind(this))
  },

  updateHeaderCartCount(name, { item_count }) {
    this.count.forEach(c => c.innerText = item_count);
  }
})
